import { useTranslations } from '@ifixit/i18n/hooks';

export function RecentlyUsedBadge() {
   const t = useTranslations('Login');
   return (
      <div className="text-xs font-medium bg-blue-50 border-blue-200 border-1 text-blue-500 px-2 rounded-b-lg -mt-2 pt-2 pb-0.5 text-center">
         {t('recentlyUsed')}
      </div>
   );
}

export function RecentlyUsedLabel() {
   const t = useTranslations('Login');
   return (
      <div className="text-xs font-medium bg-blue-50 border-blue-200 border-1 text-blue-500 px-2 py-0 m-auto rounded-lg content-center">
         {t('recentlyUsed')}
      </div>
   );
}
